import { Component, OnInit, Inject, OnChanges, SimpleChanges } from "@angular/core";
import { DOCUMENT } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { UserSessionService } from "src/app/services/usersession.service";
import swal from "sweetalert2";
import * as _ from "lodash";
import { TranslateService } from "@ngx-translate/core";
import { MatDialog } from "@angular/material/dialog";
import { NavigationService } from "src/app/services/navigation.service";
import { BalanceService } from "src/app/services/balance.service";
import { NgbDropdownConfig } from "@ng-bootstrap/ng-bootstrap";
import { filter } from "rxjs/operators";
import { AuthenticationService } from "src/app/services/authentication.service";
import { environment } from "src/environments/environment";
import * as jwtDecode from 'jwt-decode';
import { CardholderService } from "src/app/services/cardholder.service";
import { SharedService } from "src/app/services/sharedService";
@Component({
  selector: "app-navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],
  providers: [NgbDropdownConfig]
})
export class NavbarComponent implements OnInit {
  cardNo: string;
  balance: any;
  profileType: any;
  status: any;
  clicked: any;
  cardStatus: boolean = true;
  show: number;
  Webversion: any;
  number: string;
  cardbalance: any;
  auth: any;
  username: any;
  firstname: any;
  email: any;
  lastname: any;
  trackingNo: any;
  isDisable: boolean = false;
  constructor(
    @Inject(DOCUMENT) private document: Document,
    public translate: TranslateService,
    private usersessionService: UserSessionService,
    private navigationService: NavigationService,
    private router: Router,
    public dialog: MatDialog,
    private cardholderService: CardholderService,
    config: NgbDropdownConfig,
    private sharedService: SharedService
  ) {
    this.cardNo = this.usersessionService.cardNumber()
    this.trackingNo = this.usersessionService.trackingNo()
    this.firstname = this.usersessionService.cardholderName()
    config.placement = 'right-top';
    config.autoClose = true;
    this.Webversion = sessionStorage.getItem('webserverversion')


    this.sharedService.changeNavbarEmitted$.subscribe((res) => {
      this.getCardholDerdetail()
    })
  }

  ngOnInit() {
    this.clicked = 1;
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      if (event.url === '/dashboard') {
        this.clicked = 1
      } if (event.url === '/transaction') {
        this.clicked = 2;
      } if (event.url === '/smssetup') {
        this.clicked = 3;
      } if (event.url === '/blockcard') {
        this.clicked = 4;
      } if (event.url === '/wallettransfer') {
        this.clicked = 5;
      }
    });
    this.getCardholDerdetail()
  }

  getCardholDerdetail() {
    var data =
    {
      'cardNo': this.trackingNo
    }
    this.cardholderService.CardholDerdetail(data).subscribe(res => {
      this.status = res.value.resultString.status
      this.isDisable = this.status == "Active" ? true : false
    })
  }
  gotoDashboard() {
    this.clicked = 1;
    this.navigationService.goToDashboard()
  }

  gotoBlockcard() {
    this.clicked = 4;
    this.navigationService.gotoBlockCard();
  }

  goToWalletTransfer() {
    this.clicked = 5;
    this.navigationService.goToWalletTransfer();
  }

  gotoTranscation() {
    this.clicked = 2;
    this.router.navigate(['transaction']);
  }

  gotoWallet() {
    this.router.navigate(['wallet']);
  }

  gotosmssetup() {
    this.clicked = 3;
    this.router.navigate(['smssetup']);
  }



  onLogout(e) {
    e.preventDefault();
    const title = this.translate.instant("Would you like to logout?");
    const Yes = this.translate.instant("Yes");
    const No = this.translate.instant("No");
    swal
      .fire({
        title,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: Yes,
        cancelButtonText: No,
      })
      .then((result) => {
        if (result.value) {
          e.preventDefault();
          sessionStorage.clear()
          sessionStorage.removeItem("isLoggedin");
          if (!sessionStorage.getItem("isLoggedin")) {
            this.router.navigate(["/auth/login"]);
          }
        }
      });
  }

}
